<template>
  <div class="form-unit">
    <template>
      <div class="input-wrap">
        <input type="number" disabled v-bind:value="prevTierValue" />
      </div>
      <div class="input-devider" v-if="!isLastTier || isFirstTier">-</div>
    </template>
    <roe-error-message
      v-if="!isLastTier || isFirstTier"
      :field="tier.yos_upper_limit"
      :min-value="prevTierValue + 1"
    >
      <input
        type="number"
        v-model.number="tier.$model.yos_upper_limit"
        class="input-percent-small service-years-editable"
        required
        max="50"
      />
    </roe-error-message>
    <template v-if="isLastTier && !isFirstTier">
      <div class="input-devider"></div>
      <div class="input-wrap">
        <span>or more</span>
      </div>
    </template>
  </div>
</template>

<script>
import RoeErrorMessage from "@/components/_shared/inputs/ErrorMessage";
export default {
  name: "RoeTierYosUpperLimitInput",
  components: { RoeErrorMessage },
  props: {
    tier: Object,
    tiers: Array,
    index: Number,
    showFromLimit: Boolean
  },
  computed: {
    isLastTier() {
      return this.index === this.tiers.length - 1;
    },
    isFirstTier() {
      return this.index === 0;
    },
    prevTierValue() {
      return this.isFirstTier ? 0 : +this.tiers[this.index - 1].yos_upper_limit;
    }
  },
  watch: {
    prevTierValue: function() {
      this.setYosUpperLimit();
    }
  },
  mounted() {
    this.setYosUpperLimit();
  },
  methods: {
    setYosUpperLimit() {
      if (this.isLastTier)
        this.tier.$model.yos_upper_limit = this.prevTierValue;
    }
  }
};
</script>
